import React, { useEffect, useState } from "react";
import "../App.css";
import "../AccountForms.css";
import { Link, useNavigate, useLocation } from "react-router-dom";
import InvalidText from "./InvalidText";

const LoginForm = ({ setLoggedIn }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [sessionToken, setSessionToken] = useState("");
  const [InvalidAttempt, setInvalidAttempt] = useState(false);
  const [redirectMessage, setRedirectMessage] = useState("");
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Check if user was redirected from a protected route
  useEffect(() => {
    if (location.state && location.state.message) {
      setRedirectMessage(location.state.message);
    }
  }, [location]);

  const submitHandler = (event) => {
    // event.preventDefault() prevents the browser from performing its default action
    // In this instance, it will prevent the page from reloading
    // keeps the form from actually submitting as well
    event.preventDefault();
    
    // Prevent multiple submissions
    if (isLoggingIn) return;
    
    setIsLoggingIn(true);
    setInvalidAttempt(false);

    fetch(process.env.REACT_APP_API_PATH + "/auth/login", {
      method: "POST",
      headers: { 
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        password,
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.userID) {
          // Successfully logged in
          // console.log(result); 
          // set the auth token and user ID in the session state
          sessionStorage.setItem("token", result.token);
          sessionStorage.setItem("user", result.userID);
          // call setLoggedIn hook from App.jsx to save the login state throughout the app
          setLoggedIn(true);
          setSessionToken(result.token);
          // console.log(sessionToken, " SESSION TOKEN");
          
          // If redirected from somewhere, go back there
          if (location.state && location.state.from) {
            navigate(location.state.from);
          } else {
            // Otherwise go to the homepage
            navigate("/");
          }
        } else {
          setInvalidAttempt(true);
          setIsLoggingIn(false);
        }
      })
      .catch((err) => {
        // console.log(err);
        // console.log("INVALID LOGIN")
        setInvalidAttempt(true);
        setIsLoggingIn(false);
      });
  };

  return (
    <>
    <img class='formLogo' src="newLogo.png" alt="Logo" style={{width:"250px", height: "250px"}} />
    <div className="form-bubble">
    <div className="top-bubble">
    <h2 className="title-card">Log In</h2>
      {/* <h1>Login</h1> */}
      {redirectMessage && (
        <div className="redirect-message" style={{
          backgroundColor: "#f8d7da", 
          color: "#721c24", 
          padding: "10px", 
          borderRadius: "5px", 
          marginBottom: "15px",
          textAlign: "center"
        }}>
          {redirectMessage}
        </div>
      )}
      <form onSubmit={submitHandler}>
      <span className="form-label-span">Email</span>
        <label>
          {/* Email */}
          <input
            className="form-entry"
            type="email"
            autoComplete="off"
            // placeholder="Email:"
            // event.target refers to the DOM that is triggered from an event, such as onChange, onClick, etc.
            // event.target.value holds the value that is passed in to the input field from the onChange
            onChange={(event) => setEmail(event.target.value)}
          />
        </label>
        <br />
        <br />
        <span className="form-label-span">Password</span>
        <label>
          {/* Password */}
          <input
            className="form-entry"
            type="password"
            // placeholder="Password:"
            onChange ={(event) => setPassword(event.target.value)}
            
          />
        </label>
        {InvalidAttempt ? <InvalidText></InvalidText>
        :
        <br></br>
        }
        <br />
        <input 
          type="submit" 
          className="submitbutton" 
          id="form-submit" 
          autoComplete="off"
          value={isLoggingIn ? "Logging In..." : "Log In"} 
          disabled={isLoggingIn}
        />
      </form>
      <br />
      <div>
        <p>
        <Link to="/reset-password" className="forgot-link">Forgot Your Password?</Link>
        </p>
      </div>
      </div>
      <br />
      {/* BORDER BETWEEN DIVS */}
      <div></div>
      <div className="bottom-bubble">
      <h2 className="title-card" style={{marginBottom:"-15px", fontSize:"20px"}}>Not Signed Up?</h2>

      <div>
        {/* <p>not</p> */}
        <p>
          <div className="form-entry" id="register-bubble">
            <Link to="/signup" id="uncolored-link" >Register</Link>
          </div>
        </p>
      </div>
      </div>

    </div>
    
      {/* <div>
        <p>
          Reset your password <Link to="/reset-password">here</Link>
        </p>
      </div> */}
    </>
  );
};

export default LoginForm;
